import React from 'react';
import './sites.css';
import { connect } from 'react-redux';
import { updateSiteFilter, updateSelectedSite } from '../../../actions/adminActions/sitesActions';
import { sites } from '../../../apis/backend'; //make sure to include this for each page
import EditSiteModal from './siteModals/editSiteModal.jsx';
import AddSiteModal from './siteModals/addSiteModal.jsx';

class Sites extends React.Component {
  async siteDeleteRequest(id) {
    await sites
      .delete(`/${id}`, {
        headers: { authorization: this.props.employeeToken }
      })
      .catch((response) => {
        console.log(response);
      });
  }

  rendersites() {
    //renders the sites table
    return (
      <>
        {this.props.sites
          .filter((site) => {
            const filterString = `${site.name}`;
            return filterString.toLowerCase().indexOf(this.props.siteFilter.toLowerCase()) > -1;
          })
          .map((site) => (
            <tr key={this.props.sites.indexOf(site)}>
              <td className="text-center" style={{ width: '24%' }}>
                {`${site.name}`}
              </td>
              <td className="text-center permission-super-admin " style={{ width: '9%' }}>
                <div
                  data-target="#exampleModal"
                  className="btn btn-sm btn-dark"
                  data-toggle="modal"
                  onClick={() => {
                    this.props.updateSelectedSite(site.id);
                  }}
                >
                  Edit
                </div>
              </td>
              <td className="text-center permission-super-admin " style={{ width: '9%' }}>
                <div
                  className="btn btn-sm btn-dark"
                  data-target="#deleteModal"
                  data-toggle="modal"
                  onClick={() => {
                    this.props.updateSelectedSite(site.id);
                  }}
                >
                  Remove
                </div>
              </td>
            </tr>
          ))}
      </>
    );
  }

  getSiteName() {
    const site = this.props.sites.find((obj) => obj.id === this.props.selectedSite);

    return site ? site.name : '';
  }

  render() {
    return (
      <div className="sites-page">
        <div className="container">
          <div
            className="form-inline md-form form-sm mt-4"
            style={{ fontSize: '36px', color: '#fff' }}
          >
            <div style={{ margin: 'auto', height: '48px', width: '100%' }}>Sites</div>
          </div>
          <div className="form-inline md-form form-sm mt-3">
            <input
              value={this.props.siteFilter}
              className="form-control form-control-lg w-45"
              type="text"
              placeholder="Search"
              aria-label="Search"
              onChange={(e) => {
                this.props.updateSiteFilter(e.target.value);
              }}
            />
            <div
              data-target="#addModal"
              className="btn btn-lg btn-dark permission-super-admin"
              data-toggle="modal"
              style={{ marginLeft: '10px' }}
            >
              Add Site
            </div>
          </div>
          <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table className="table table-striped  table-bordered table-hover bg-white mt-1 mr-3">
              <thead className="bg-dark thead-dark">
                <tr>
                  <th className="text-center" style={{ width: '24%' }}>
                    Name
                  </th>
                  <th className="text-center permission-super-admin " style={{ width: '9%' }}>
                    Edit
                  </th>
                  <th className="text-center permission-super-admin " style={{ width: '9%' }}>
                    Remove
                  </th>
                </tr>
              </thead>
              <tbody>{this.rendersites()}</tbody>
            </table>
          </div>
        </div>

        <AddSiteModal />
        <EditSiteModal />

        <div className="modal fade" id="deleteModal" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content" style={{ width: '80%', margin: '0 auto' }}>
              <div className="modal-header">
                <h5 className="modal-title">Are you Sure?</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    this.props.updateSelectedSite(0);
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body" style={{ textAlign: 'center', fontSize: '18px' }}>
                <strong>&apos;{this.getSiteName()}&apos;</strong> will be deleted forever!!
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.siteDeleteRequest(this.props.selectedSite);
                    this.props.updateSelectedSite(0);
                  }}
                >
                  Yes
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.props.updateSelectedSite(0);
                  }}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  sites: state.admin.admin.sites,
  siteFilter: state.admin.sites.siteFilter,
  selectedSite: state.admin.sites.selectedSite,
  employeeToken: state.auth.employeeToken
});

export default connect(mapStateToProps, {
  updateSiteFilter,
  updateSelectedSite
})(Sites);
